import { DateString } from "./commonTypes"

export const STUDENT_NOTIFICATION_EVENT = "student-notification-event"

export type StudentNotificationSubscribeEvent = {
    type: "connection-established" | "new-notification" | "unread-notifications"
    message: string
}

export const StudentNotificationTypes = ["submission-graded", "submission-rework", "submission-reject"] as const
export type StudentNotificationType = typeof StudentNotificationTypes[number]

export const StudentNotificationStatuses = ["read", "unread"] as const
export type StudentNotificationStatus = typeof StudentNotificationStatuses[number]

export type StudentNotification = {
    id: string
    customerUsername: string
    studentId: string
    submissionId: string
    created: DateString
    assignment: {
        id: string
        title: string
    }
    type: StudentNotificationType
    status: StudentNotificationStatus
}

export const NOTIFICATIONS_PER_PAGE = 10
export const PAGES_PER_SET_NOTIFICATIONS = 5
